import { Action } from '@ngrx/store'
import * as compoundsTypes from './compounds.types'
import { Compound } from './compounds.interface'

export class FetchCompoundsRequest implements Action {
  readonly type = compoundsTypes.FETCH_COMPOUNDS_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchCompoundsSuccess implements Action {
  readonly type = compoundsTypes.FETCH_COMPOUNDS_SUCCESS
  constructor(public payload: Compound[], public total: number) {}
}

export class FetchCompoundsFailure implements Action {
  readonly type = compoundsTypes.FETCH_COMPOUNDS_FAILURE
  constructor(public payload: any) {}
}

export class FetchCompoundRequest implements Action {
  readonly type = compoundsTypes.FETCH_COMPOUND_REQUEST
  constructor(public id: number) {}
}

export class FetchCompoundSuccess implements Action {
  readonly type = compoundsTypes.FETCH_COMPOUND_SUCCESS
  constructor(public payload: any, public building?: any) {}
}

export class FetchCompoundFailure implements Action {
  readonly type = compoundsTypes.FETCH_COMPOUND_FAILURE
  constructor(public payload: any) {}
}

export class UpdateCompoundRequest implements Action {
  readonly type = compoundsTypes.UPDATE_COMPOUND_REQUEST
  constructor(public id: number, public payload: any) {}
}

export class UpdateCompoundSuccess implements Action {
  readonly type = compoundsTypes.UPDATE_COMPOUND_SUCCESS
  constructor(public payload: any) {}
}

export class UpdateCompoundFailure implements Action {
  readonly type = compoundsTypes.UPDATE_COMPOUND_FAILURE
  constructor(public payload: any) {}
}

export class CreateCompoundRequest implements Action {
  readonly type = compoundsTypes.CREATE_COMPOUND_REQUEST
  constructor(public payload: any) {}
}

export class CreateCompoundSuccess implements Action {
  readonly type = compoundsTypes.CREATE_COMPOUND_SUCCESS
  constructor(public payload: any) {}
}

export class CreateCompoundFailure implements Action {
  readonly type = compoundsTypes.CREATE_COMPOUND_FAILURE
  constructor(public payload: any) {}
}

// Common

export class UpdateField implements Action {
  readonly type = compoundsTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class FetchCompoundPaymentsRequest implements Action {
  readonly type = compoundsTypes.FETCH_COMPOUND_PAYMENTS_REQUEST
  constructor(public id: number) {}
}

export class FetchCompoundPaymentsSuccess implements Action {
  readonly type = compoundsTypes.FETCH_COMPOUND_PAYMENTS_SUCCESS
  constructor(public payload: any) {}
}

export class FetchCompoundPaymentsFailure implements Action {
  readonly type = compoundsTypes.FETCH_COMPOUND_PAYMENTS_FAILURE
  constructor(public payload: any) {}
}

export class CreateCompoundPaymentRequest implements Action {
  readonly type = compoundsTypes.CREATE_COMPOUND_PAYMENT_REQUEST
  constructor(public payload: any) {}
}

export class CreateCompoundPaymentSuccess implements Action {
  readonly type = compoundsTypes.CREATE_COMPOUND_PAYMENT_SUCCESS
  constructor(public payload: any) {}
}

export class CreateCompoundPaymentFailure implements Action {
  readonly type = compoundsTypes.CREATE_COMPOUND_PAYMENT_FAILURE
  constructor(public payload: any) {}
}

export class UpdateCompoundPaymentRequest implements Action {
  readonly type = compoundsTypes.UPDATE_COMPOUND_PAYMENT_REQUEST
  constructor(public payload: any) {}
}

export class UpdateCompoundPaymentSuccess implements Action {
  readonly type = compoundsTypes.UPDATE_COMPOUND_PAYMENT_SUCCESS
  constructor(public payload: any) {}
}

export class UpdateCompoundPaymentFailure implements Action {
  readonly type = compoundsTypes.UPDATE_COMPOUND_PAYMENT_FAILURE
  constructor(public payload: any) {}
}

export class DeleteCompoundPaymentRequest implements Action {
  readonly type = compoundsTypes.DELETE_COMPOUND_PAYMENT_REQUEST
  constructor(public payload: any) {}
}

export class DeleteCompoundPaymentSuccess implements Action {
  readonly type = compoundsTypes.DELETE_COMPOUND_PAYMENT_SUCCESS
  constructor(public payload: any) {}
}

export class DeleteCompoundPaymentFailure implements Action {
  readonly type = compoundsTypes.DELETE_COMPOUND_PAYMENT_FAILURE
  constructor(public payload: any) {}
}

export class DownloadCompoundPaymentRequest implements Action {
  readonly type = compoundsTypes.DOWNLOAD_COMPOUND_PAYMENT_REQUEST
  constructor(public payload: any) {}
}

export class DownloadCompoundPaymentSuccess implements Action {
  readonly type = compoundsTypes.DOWNLOAD_COMPOUND_PAYMENT_SUCCESS
  constructor(public payload: any) {}
}

export class DownloadCompoundPaymentFailure implements Action {
  readonly type = compoundsTypes.DOWNLOAD_COMPOUND_PAYMENT_FAILURE
  constructor(public payload: any) {}
}

export class FetchCompoundDocumentsRequest implements Action {
  readonly type = compoundsTypes.FETCH_COMPOUND_DOCUMENTS_REQUEST
  constructor(public id: number) {}
}

export class FetchCompoundDocumentsSuccess implements Action {
  readonly type = compoundsTypes.FETCH_COMPOUND_DOCUMENTS_SUCCESS
  constructor(public payload: any) {}
}

export class FetchCompoundDocumentsFailure implements Action {
  readonly type = compoundsTypes.FETCH_COMPOUND_DOCUMENTS_FAILURE
  constructor(public payload: any) {}
}

export class DownloadCompoundDocumentRequest implements Action {
  readonly type = compoundsTypes.DOWNLOAD_COMPOUND_DOCUMENT_REQUEST
  constructor(public payload: any) {}
}

export class DownloadCompoundDocumentSuccess implements Action {
  readonly type = compoundsTypes.DOWNLOAD_COMPOUND_DOCUMENT_SUCCESS
  constructor(public payload: any, public document: Map<string, any>) {}
}

export class DownloadCompoundDocumentFailure implements Action {
  readonly type = compoundsTypes.DOWNLOAD_COMPOUND_DOCUMENT_FAILURE
  constructor(public payload: any) {}
}

export class GenerateCompoundDocumentRequest implements Action {
  readonly type = compoundsTypes.GENERATE_COMPOUND_DOCUMENT_REQUEST
  constructor(public payload: any) {}
}

export class GenerateCompoundDocumentSuccess implements Action {
  readonly type = compoundsTypes.GENERATE_COMPOUND_DOCUMENT_SUCCESS
  constructor(public payload: any, public document: Map<string, any>) {}
}

export class GenerateCompoundDocumentFailure implements Action {
  readonly type = compoundsTypes.GENERATE_COMPOUND_DOCUMENT_FAILURE
  constructor(public payload: any) {}
}

export class DeleteCompoundDocumentRequest implements Action {
  readonly type = compoundsTypes.DELETE_COMPOUND_DOCUMENT_REQUEST
  constructor(public payload: any) {}
}

export class DeleteCompoundDocumentSuccess implements Action {
  readonly type = compoundsTypes.DELETE_COMPOUND_DOCUMENT_SUCCESS
  constructor(public payload: any) {}
}

export class DeleteCompoundDocumentFailure implements Action {
  readonly type = compoundsTypes.DELETE_COMPOUND_DOCUMENT_FAILURE
  constructor(public payload: any) {}
}

export class SetDefaultData implements Action {
  readonly type = compoundsTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | SetDefaultData
  | UpdateField
  | FetchCompoundsRequest
  | FetchCompoundsSuccess
  | FetchCompoundsFailure
  | FetchCompoundRequest
  | FetchCompoundSuccess
  | FetchCompoundFailure
  | UpdateCompoundRequest
  | UpdateCompoundSuccess
  | UpdateCompoundFailure
  | CreateCompoundRequest
  | CreateCompoundSuccess
  | CreateCompoundFailure
  | FetchCompoundPaymentsRequest
  | FetchCompoundPaymentsSuccess
  | FetchCompoundPaymentsFailure
  | CreateCompoundPaymentRequest
  | CreateCompoundPaymentSuccess
  | CreateCompoundPaymentFailure
  | UpdateCompoundPaymentRequest
  | UpdateCompoundPaymentSuccess
  | UpdateCompoundPaymentFailure
  | DeleteCompoundPaymentRequest
  | DeleteCompoundPaymentSuccess
  | DeleteCompoundPaymentFailure
  | DownloadCompoundPaymentRequest
  | DownloadCompoundPaymentSuccess
  | DownloadCompoundPaymentFailure
  | FetchCompoundDocumentsRequest
  | FetchCompoundDocumentsSuccess
  | FetchCompoundDocumentsFailure
  | DownloadCompoundDocumentRequest
  | DownloadCompoundDocumentSuccess
  | DownloadCompoundDocumentFailure
  | GenerateCompoundDocumentRequest
  | GenerateCompoundDocumentSuccess
  | GenerateCompoundDocumentFailure
  | DeleteCompoundDocumentRequest
  | DeleteCompoundDocumentSuccess
  | DeleteCompoundDocumentFailure
